<template>
    <div class="flex h-screen overflow-hidden bg-gray-100">
        <!-- Off-canvas menu for mobile -->
        <div v-show="sidebarOpen" class="md:hidden">
            <div
                @click="sidebarOpen = false"
                v-show="sidebarOpen"
                class="fixed inset-0 z-30 transition-opacity duration-300 ease-linear"
            >
                <div class="absolute inset-0 bg-gray-600 opacity-75"></div>
            </div>
            <div class="fixed inset-0 z-40 flex">
                <div
                    v-show="sidebarOpen"
                    class="flex flex-col flex-1 w-full max-w-xs pt-5 pb-4 duration-300 ease-in-out transform bg-blue-600"
                >
                    <div class="absolute top-0 right-0 p-1 -mr-14">
                        <button
                            v-show="sidebarOpen"
                            @click="sidebarOpen = false"
                            class="flex items-center justify-center w-12 h-12 rounded-full focus:outline-none focus:bg-gray-600"
                        >
                            <svg
                                class="w-6 h-6 text-white"
                                stroke="currentColor"
                                fill="none"
                                viewBox="0 0 24 24"
                            >
                                <path
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-width="2"
                                    d="M6 18L18 6M6 6l12 12"
                                />
                            </svg>
                        </button>
                    </div>
                    <div class="flex items-center flex-shrink-0 px-4">
                        <h1
                            class="w-auto h-8 px-4 text-3xl font-black text-white sm:h-10"
                        >
                        CRIms
                            <span class="text-2xl font-normal"
                                >BusinessPlan</span
                            >
                        </h1>
                    </div>
                    <div class="flex-1 h-0 mt-5 overflow-y-auto">
                        <nav class="flex flex-col justify-between">
                            <div v-for="(step, index) in steps" :key="index">
                                <a
                                    @click="
                                        $store.dispatch(
                                            'forms/showSubStep',
                                            index
                                        )
                                    "
                                    href="#"
                                    class="flex items-center px-2 py-2 mt-1 ml-2 text-base font-bold leading-5 text-white transition duration-150 ease-in-out rounded-md group h-14 hover:text-white hover:bg-blue-700 focus:outline-none focus:bg-blue-700"
                                >
                                    <svg
                                        class="w-12 h-12 px-1 py-1 mr-3 font-bold text-white text-opacity-100 transition duration-150 ease-in-out"
                                        stroke="currentColor"
                                        fill="none"
                                    >
                                        <circle
                                            cx="18"
                                            cy="18"
                                            r="18"
                                            fill="white"
                                        />
                                        <text
                                            x="45%"
                                            y="60%"
                                            text-anchor="middle"
                                            fill="currentColor"
                                            class="font-bold text-blue-600"
                                        >
                                            {{ step.id }}
                                        </text>
                                    </svg>
                                    {{ step.title }}
                                </a>
                                <ul class="ml-16" v-show="step.show">
                                    <li
                                        v-for="(substep, key) in step.subSteps"
                                        :key="key"
                                    >
                                        <a
                                            href="#"
                                            class="flex items-center px-2 py-2 leading-5 text-left transition duration-150 ease-in-out h-14 rounded-l-md hover:text-white hover:bg-blue-700"
                                            :class="{
                                                'text-white bg-blue-800':
                                                    substep.done,
                                                'text-blue-300 focus:text-blue-600 focus:bg-gray-200': !substep.done
                                            }"
                                            >{{ substep.title }}</a
                                        >
                                    </li>
                                </ul>
                            </div>
                            <div>
                                <a
                                    href="#"
                                    class="flex items-center px-2 py-2 mt-1 ml-2 text-base font-bold leading-5 text-white transition duration-150 ease-in-out rounded-md group h-14 hover:text-white hover:bg-blue-700 focus:outline-none focus:bg-blue-700"
                                >
                                    <svg
                                        class="w-6 h-6"
                                        fill="none"
                                        stroke="currentColor"
                                        viewBox="0 0 24 24"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                            stroke-width="2"
                                            d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"
                                        ></path>
                                    </svg>
                                    Déconnexion
                                </a>
                            </div>
                        </nav>
                    </div>
                </div>
                <div class="flex-shrink-0 w-14">
                    <!-- Force sidebar to shrink to fit close icon -->
                </div>
            </div>
        </div>

        <!-- Static sidebar for desktop -->
        <div class="hidden md:flex md:flex-shrink-0">
            <div class="flex flex-col pt-5 pb-4 bg-blue-600 w-96">
                <div class="flex items-center flex-shrink-0 px-4">
                    <h1
                        @click="goToHome"
                        class="w-auto h-8 px-4 text-3xl font-black text-white cursor-pointer sm:h-10"
                    >
                        CRIms
                        <span class="text-2xl font-normal">BusinessPlan</span>
                    </h1>
                </div>
                <div class="flex flex-col flex-1 h-0 mt-5 overflow-y-auto">
                    <!-- Sidebar component, swap this element with another sidebar if you like -->
                    <nav class="flex flex-col flex-1 bg-blue-600">
                        <div v-for="(step, index) in steps" :key="index">
                            <a
                                @click="
                                    $store.dispatch('forms/showSubStep', index)
                                "
                                href="#"
                                class="flex items-center px-2 py-4 text-base font-bold leading-5 text-white transition duration-150 ease-in-out rounded-md shadow-xl group h-14 focus:outline-none"
                                :class="{
                                    'bg-blue-800': step.done,
                                    'hover:text-white hover:bg-blue-700': !step.done
                                }"
                            >
                                <base-icon
                                    v-if="step.done"
                                    class="w-12 h-12 mr-3"
                                    width="100"
                                    height="100"
                                    viewBox="0 0 20 20"
                                    icon-name="check"
                                    iconColor="white"
                                >
                                    <check-icon />
                                </base-icon>
                                <!-- <svg
                  
                  class="w-12 h-12 px-1 py-1 mr-3 font-bold text-white text-opacity-100 transition duration-150 ease-in-out"
                  stroke="currentColor"
                  fill="none"
                >
                  <circle cx="19" cy="19" r="19" fill="white" />
                  <text
                    x="45%"
                    y="60%"
                    text-anchor="middle"
                    fill="currentColor"
                    class="font-bold text-blue-600"
                  >
                    {{ step.id }}
                  </text>
                </svg> -->
                                <div class="flex items-center mr-3">
                                    <div
                                        v-if="!step.done"
                                        class="flex items-center justify-center w-10 h-10 bg-white rounded-full"
                                    >
                                        <span
                                            class="text-lg font-bold text-center text-blue-600 inset-y-1/2 "
                                            >{{ step.id }}</span
                                        >
                                    </div>
                                </div>
                                {{ step.title }}
                            </a>
                            <ul class="ml-16" v-show="step.show">
                                <li
                                    v-for="(substep, key) in step.subSteps"
                                    :key="key"
                                    @click="substep.focus = true"
                                >
                                    <component
                                        :is="isAccessible(step.subSteps, key)"
                                        :to="{ name: substep.pathName }"
                                        class="flex items-center pt-4 leading-5 text-left text-white transition duration-150 ease-in-out h-14"
                                        :class="{
                                            'text-white bg-blue-800':
                                                substep.done,
                                            'text-blue-600 bg-gray-100 ':
                                                isActive(index, key) &&
                                                !substep.done
                                        }"
                                    >
                                        <base-icon
                                            v-if="substep.done"
                                            class="w-12 h-12 pb-4"
                                            width="90"
                                            height="90"
                                            icon-name="check"
                                            viewBox="0 0 20 20"
                                            iconColor="white"
                                        >
                                            <check-icon />
                                        </base-icon>
                                        <div
                                            class="flex flex-col justify-between w-full"
                                        >
                                            <span
                                                class="px-4"
                                                :class="[
                                                    !substep.done ? '' : 'pb-4'
                                                ]"
                                                >{{ substep.title }}</span
                                            >
                                        </div>
                                    </component>
                                </li>
                            </ul>
                        </div>
                        <div class="mt-auto">
                            <a
                                @click="logout"
                                class="flex items-center px-2 py-2 mt-1 ml-2 text-base font-bold leading-5 text-white transition duration-150 ease-in-out rounded-md cursor-pointer group h-14 hover:text-white hover:bg-blue-700 focus:outline-none focus:bg-blue-700"
                            >
                                <svg
                                    class="w-6 h-6"
                                    fill="none"
                                    stroke="currentColor"
                                    viewBox="0 0 24 24"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                        stroke-width="2"
                                        d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"
                                    ></path>
                                </svg>
                                <span class="ml-3">Déconnexion</span>
                            </a>
                        </div>
                    </nav>
                </div>
            </div>
        </div>
        <div class="flex flex-col flex-1 w-0 overflow-hidden">
            <main
                class="relative z-0 flex-1 py-6 overflow-y-auto focus:outline-none"
                tabindex="0"
            >
                <base-breadcrumbs />
                <div class="grid grid-cols-main ">
                    <slot></slot>
                </div>
            </main>
        </div>
    </div>
</template>

<script>
import CheckIcon from "../components/icons/CheckIcon";
import { mapMutations, mapGetters } from "vuex";

export default {
    components: {
        CheckIcon
    },
    data() {
        return {
            sidebarOpen: false
        };
    },
    computed: {
        ...mapGetters("forms", {
            steps: "getSteps"
        }),

        isActive: function() {
            return function(index, key) {
                if (
                    (key !== 0 &&
                        this.steps[index].subSteps[key - 1].done == true) ||
                    (key === 0 && index === 0)
                ) {
                    return true;
                } else {
                    if (key === 0 && this.steps[index - 1].done === true) {
                        return true;
                    }
                    return false;
                }
            };
        },
        isAccessible() {
            return (step, index) => {
                if (index === 0 || step[index - 1].done) return "router-link";
                return "template";
            };
        }
    },
    methods: {
        ...mapMutations("forms", ["SHOW_SUB_STEPS"]),

        logout() {
            this.$store.dispatch("Auth/signOut");
        },
        goToHome() {
            this.$router.push({ name: "Home" });
        }
    }
};
</script>

<style></style>
